module.exports = __webpack_public_path__ + "static/media/20240213112429_IMG_5374.3ca0dcad.JPG";